import React from 'react';

const NewgenLogo = (props) => {
  const small = 'https://pubkit.newgen.co/assets/newgen_favicon-a5862f6f5a42b784ac7612e26961341040ee668c8b8412b6ef3d4b8c4612fc57.ico';
  const large = 'https://www.newgen.co/images/Newgen-logo-final.png';

  const logoUrl = props.small ? small : large;

  return <img src={logoUrl} />;
};

export default NewgenLogo;
